import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface LanguagesDto {
  loading?: boolean;
  data: any[];
}

export const setLanguagesData = createAsyncThunk(
  "languages/setLanguagesData",
  async (data: any[]) => {
    return { data };
  }
);

export const getLanguages = createAsyncThunk(
  "languages/getLanguages",
  async () => {
    const response: any = await axios.get(APIRoutes.LANGUAGES);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const addNewLanguage = createAsyncThunk(
  "languages/addNewLanguage",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.LANGUAGES, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const updateLanguage = createAsyncThunk(
  "languages/updateLanguage",
  async (data: any) => {
    const response: any = await axios.patch(
      `${APIRoutes.LANGUAGES}/${data?.id ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const deleteLanguage = createAsyncThunk(
  "languages/deleteLanguage",
  async (id: number) => {
    const response: any = await axios.delete(`${APIRoutes.LANGUAGES}/${id}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: LanguagesDto = {
  loading: false,
  data: [],
};

export const languages = createSlice({
  name: "languages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLanguages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLanguages.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getLanguages.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setLanguagesData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data ?? [];
      });
  },
});

export default languages.reducer;
